import React, { useEffect, useState } from "react";
import { Modal,Form, Input, Button, message, InputNumber, DatePicker } from "antd";
import dayjs from "dayjs";
import { MakeApiCall } from "../../../../apis";
import { Wrapper } from "../style";

const AddCogs = ({ visible, onClose, onSave, getList, product, userData, isUpdate, sku, marketplaceId }) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && product) {
            form.setFieldsValue({
                item_cogs: product?.item_cogs || "",
                item_cogs_batch_start_date: product?.item_cogs_batch_start_date
                    ? dayjs(product.item_cogs_batch_start_date)
                    : null,
            });
        } else {
            form.resetFields();
        }
    }, [visible, product]);


    const handleFormSubmit = () => {
        form
            .validateFields()
            .then(async (values) => {
                console.log(values, 'values');

                const formattedData = {
                    item_cogs: values.item_cogs,
                    item_cogs_batch_start_date: values.item_cogs_batch_start_date
                        ? dayjs(values.item_cogs_batch_start_date).format('YYYY-MM-DD')
                        : null,
                };
                console.log(formattedData, 'formattedData');

                try {
                    let response;
                    if (sku) {
                        // Dashboard / SKU-based mode — new PUT endpoint
                        const payload = {
                            sku,
                            item_cogs: formattedData.item_cogs,
                            item_cogs_batch_start_date: formattedData.item_cogs_batch_start_date,
                            ...(marketplaceId ? { marketplace_id: marketplaceId } : {}),
                        };
                        response = await MakeApiCall('products/update-sku-cogs', 'post', payload, true, null, userData?.token);
                    } else {
                        // Products-page mode — existing POST by product id
                        response = await MakeApiCall(`update-product/${product?.id}`, 'post', formattedData, true, null, userData?.token);
                    }

                    if (response?.status) {
                        message.success(response?.message);
                        onClose(false);
                        form.resetFields();
                        getList && getList();
                    } else {
                        message.error(response?.message);
                    }
                } catch (error) {
                    message.error("Something went wrong. Please try again.");
                    console.error("Request Failed:", error);
                }
            })
            .catch((errorInfo) => {
                message.error("Validation Failed");
                console.log("Validation failed:", errorInfo);
            });
    };


    return (
        <Modal
            title="Update COGS"
            open={visible}
            width={400}
            onCancel={onClose}
            footer={[
                <button type="button" class="btn btn-light " onClick={onClose}>Close</button>,
                <button type="button" class="btn btn-danger " onClick={() => form.submit()}> Save</button>
            ]}
        >
            <p><b>Product:</b> {product?.item_name || product?.product_title}</p>
            <Form className="mt-5" form={form} onFinish={handleFormSubmit} layout="vertical">
                <Wrapper>


                    {/*end::Input group*/}
                    <div className="row g-3 mb-5 align-items-center">
                        <div className="col-md-4 fv-row">
                            <label className="fs-6 fw-bold mb-2">Cost per unit <span style={{ color: '#ff4d4f' }}>*</span></label>
                        </div>
                        <div className="col-md-8 fv-row">
                            <Form.Item
                                name="item_cogs"
                                className='mb-0'
                                rules={[{ required: true, message: 'Please enter Cost' }]}
                            >
                                <InputNumber
                                    className="w-100"
                                    variant="filled"
                                    size='large'
                                    min={0}
                                    onKeyDown={(e) => {
                                        const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', '.'];
                                        if (allowed.includes(e.key)) return;
                                        if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x', 'z'].includes(e.key.toLowerCase())) return;
                                        if (e.key < '0' || e.key > '9') { e.preventDefault(); }
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    {/*end::Input group*/}
                    <div className="row g-3 mb-5 align-items-center">
                        <div className="col-md-4 fv-row">
                            <label className="fs-6 fw-bold mb-2">Start Date</label>
                        </div>
                        <div className="col-md-8 fv-row">
                            <Form.Item
                                name="item_cogs_batch_start_date"
                                className='mb-0'
                            >
                                <DatePicker
                                    className="w-100"
                                    variant="filled"
                                    size='large'
                                    format="YYYY-MM-DD"
                                    placeholder="Select Start Date"
                                />
                            </Form.Item>
                        </div>
                    </div>
                    {/*end::Input group*/}

                </Wrapper>
            </Form>
        </Modal>
    );
};

export default AddCogs;